import {
  isMinOrderCompletionNote,
  resolveEffectiveMinimumOrder,
  roundMoney,
  MIN_ORDER_COMPLETION_NOTE_PREFIX,
} from 'shared-models/browser';
import type { MinimumOrderConfig } from 'shared-models/browser';
import { formatMoneyCompact } from '../../../../../utils/money';

type CompletionLike = { unitPrice: number; quantity: number; note: string | null };

export type MinOrderReminderState = {
  effectiveMinimum: number;
  currentTotal: number;
  missing: number;
  completionAmount: number;
  hasCompletionLine: boolean;
};

export function buildMinOrderCompletionNote(minimumAmount: number): string {
  return `${MIN_ORDER_COMPLETION_NOTE_PREFIX} ${formatMoneyCompact(minimumAmount)} ₪`;
}

export function computeMinOrderReminderState(
  config: MinimumOrderConfig,
  dinersCount: number,
  fullTotal: number,
  lines: CompletionLike[],
): MinOrderReminderState {
  const completionLines = lines.filter((line) => isMinOrderCompletionNote(line.note));
  const completionTotal = completionLines.reduce((sum, line) => sum + line.unitPrice * line.quantity, 0);
  const currentTotal = roundMoney(fullTotal);
  const withoutCompletion = roundMoney(currentTotal - completionTotal);
  const effectiveMinimum = resolveEffectiveMinimumOrder(config, dinersCount);

  return {
    effectiveMinimum,
    currentTotal,
    missing: currentTotal >= effectiveMinimum ? 0 : roundMoney(effectiveMinimum - currentTotal),
    completionAmount: effectiveMinimum > withoutCompletion ? roundMoney(effectiveMinimum - withoutCompletion) : 0,
    hasCompletionLine: completionLines.length > 0,
  };
}
